import CurrencyFieldBase from '../base/CurrencyField';
import createField from './createField';

const CurrencyField = createField(CurrencyFieldBase);

export default CurrencyField;
